module.exports = __webpack_public_path__ + "static/img/ca4569d2-e4c3-4dec-8bfe-52712ef6bc31.52c259e.svg";